// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__cBk5H","select":"Header_select__1AA3I","clinic":"Header_clinic__3YnHR"};